/** @format */

import React, { FunctionComponent as FC } from 'react';

export const ImgSlide: FC<ImageSlideProps> = ({ photo, index }) => (
  <img className="swiper-zoom-target" src={photo} alt={`room-${index + 1}`} />
);

interface ImageSlideProps {
  photo: string;
  index: number;
}
